import request from '@/utils/request'
const key = 'auth'
export function login(data) {
  return request({
    url: `/platform/${key}/login`,
    method: 'post',
    data
  })
}

export function getInfo(params) {
  return request({
    url: `/platform/${key}/accountMe`,
    method: 'get',
    params
  })
}

export function logout() {
  return request({
    url: `/platform/${key}/logout`,
    method: 'post'
  })
}

export function resetPassword(data) {
  return request({
    url: `/platform/${key}/resetPassword`,
    method: 'post',
    data
  })
}
